import SubscriptionsService from '../../services/subscriptions.service.js';
import PlansService from '../../services/plans.service.js';

export const state = {
  expirationDate: '',
  total: 0,
  type: '',
  planData: null,
  currentSubscription: null
};

export const mutations = {
  SET_SUBSCRIPTION(state, subscription) {
    state.expirationDate = subscription.expirationDate;
    state.total = subscription.total;
    state.type = subscription.type;
    state.currentSubscription = subscription.currentSubscription;
  },
  SET_PLAN(state, planData) {
    state.planData = planData;
  }
};

export const actions = {
  async getClientCredits({ commit }) {
    try {
      const { selectedClientId } = this.state.profile.profileData;
      const { data: credits } = await SubscriptionsService.getClientCredits(selectedClientId);
      commit('SET_SUBSCRIPTION', { total: credits.available, type: 'Credits' });
    } catch (err) {
      console.error(err);
    }
  },
  async getClientUsers({ commit }) {
    try {
      const { selectedClientId } = this.state.profile.profileData;
      const { data } = await SubscriptionsService.getClientUsers(selectedClientId);
      if (data.docs && data.docs.length) {
        const currentSubscription = data.docs[0];
        commit('SET_SUBSCRIPTION', {
          expirationDate: currentSubscription.endDate,
          total: currentSubscription.rateLimit - currentSubscription.rateConsumed,
          // This must be uppercase because of 'account.lms${type}' labels
          type: 'Users',
          currentSubscription
        });
      }
    } catch (err) {
      console.error(err);
    }
  },
  async sendCancelPlanEmail({ commit, dispatch }) {
    try {
      const { distributorId, fullName, selectedClientId, role } = this.state.profile.profileData;
      const { data: plan } = await PlansService.sendCancelPlanEmail(
        distributorId ? distributorId : selectedClientId,
        fullName,
        role
      );
      commit('SET_PLAN', plan);
      let notification = {
        type: 'success',
        message: `feedback.success.cancelSubscription`,
        show: true
      };
      dispatch('addNotification', notification);
      return plan;
    } catch (err) {
      console.error(err);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  async getPlan({ commit }) {
    try {
      const { clientId } = this.state.profile.profileData;
      if (clientId) {
        const { data: plan } = await PlansService.getlPlan(clientId);
        commit('SET_PLAN', plan);
        return plan;
      }
    } catch (err) {
      console.error(err);
    }
  },
  async getClientPlan({ commit }) {
    try {
      const { selectedClientId } = this.state.profile.profileData;
      if (selectedClientId) {
        const { data: plan } = await PlansService.getlPlan(selectedClientId);
        commit('SET_PLAN', plan);
        return plan;
      }
    } catch (err) {
      console.error(err);
    }
  }
};
